const constant = {
    authToken: "",
    tokenRes: "",
    paymentNonce: "",
    isLinkage: "",
    userData: "",
    location: "",
    menu: "",
    userId: "",
    partnerId: "",
    contactLocation: "",
    bookId: "",
    methodData: "",
    tokenTransfer: "",
    colorTheme: "",
    billerData: "",
    language: ""
}

//SAVE LOCAL STORAGE
export const saveAuthToken = (value: string) => localStorage.setItem(Object.keys(constant)[0], value);
export const saveTokenRegis = (value: string) => localStorage.setItem(Object.keys(constant)[1], value);
export const savePaymentNonce = (value: string) => localStorage.setItem(Object.keys(constant)[2], value);
export const saveLinkage = (value: string) => localStorage.setItem(Object.keys(constant)[3], value);
export const saveUserData = (value: string) => localStorage.setItem(Object.keys(constant)[4], value);
export const saveLocation = (value: string) => localStorage.setItem(Object.keys(constant)[5], value);
export const saveMenu = (value: string) => localStorage.setItem(Object.keys(constant)[6], value);
export const saveUserId = (value: string) => localStorage.setItem(Object.keys(constant)[7], value);
export const savePartnerId = (value: string) => localStorage.setItem(Object.keys(constant)[8], value);
export const saveBookId = (value: string) => localStorage.setItem(Object.keys(constant)[10], value);
export const saveMethodData = (value: string) => localStorage.setItem(Object.keys(constant)[11], value);
export const saveTokenTransfer = (value: any) => localStorage.setItem(Object.keys(constant)[12], JSON.stringify(value));
export const saveColorTheme = (value: string) => localStorage.setItem(Object.keys(constant)[13], value);
export const saveBillerData = (value: string) => localStorage.setItem(Object.keys(constant)[14], JSON.stringify(value));
export const saveLanguage = (value: string) => localStorage.setItem(Object.keys(constant)[15], value);

//GET LOCAL STORAGE
export const getAuthToken = () => localStorage.getItem(Object.keys(constant)[0]);
export const getTokenRegis = () => localStorage.getItem(Object.keys(constant)[1]);
export const getPaymentNonce = () => localStorage.getItem(Object.keys(constant)[2]);
export const getLinkage = () => localStorage.getItem(Object.keys(constant)[3]);
export const getUserData = () => localStorage.getItem(Object.keys(constant)[4]);
export const getLocation = () => localStorage.getItem(Object.keys(constant)[5]);
export const getMenu = () => localStorage.getItem(Object.keys(constant)[6]);
export const getUserId = () => localStorage.getItem(Object.keys(constant)[7]);
export const getPartnerId = () => localStorage.getItem(Object.keys(constant)[8]);
export const getBookId = () => localStorage.getItem(Object.keys(constant)[10]);
export const getMethodData = () => localStorage.getItem(Object.keys(constant)[11]);
export const getTokenTransfer = () => {
    const storedData = localStorage.getItem(Object.keys(constant)[12]);
    return storedData ? JSON.parse(storedData) : null;
}
export const getColorTheme = () => localStorage.getItem(Object.keys(constant)[13]);
export const getBillerData = () => {
    const storedData = localStorage.getItem(Object.keys(constant)[14]);
    return storedData ? JSON.parse(storedData) : null;
};
export const getLanguage = () => localStorage.getItem(Object.keys(constant)[15]);

//REMOVE LOCAL STORAGE
export const removeAuthToken = () => localStorage.removeItem(Object.keys(constant)[0]);
export const removeTokenRegis = () => localStorage.removeItem(Object.keys(constant)[1]);
export const removePaymentNonce = () => localStorage.removeItem(Object.keys(constant)[2]);
export const removeLinkage = () => localStorage.removeItem(Object.keys(constant)[3]);
export const removeUserData = () => localStorage.removeItem(Object.keys(constant)[4]);
export const removeLocation = () => localStorage.removeItem(Object.keys(constant)[5]);
export const removeMenu = () => localStorage.removeItem(Object.keys(constant)[6]);
export const removeUserId = () => localStorage.removeItem(Object.keys(constant)[7]);
export const removePartnerId = () => localStorage.removeItem(Object.keys(constant)[8]);
export const removeContactLocation = () => localStorage.removeItem(Object.keys(constant)[9]);
export const removeBookId = () => localStorage.removeItem(Object.keys(constant)[10]);
export const removeMethodData = () => localStorage.removeItem(Object.keys(constant)[11]);
export const removeTokenTransfer = () => localStorage.removeItem(Object.keys(constant)[12]);
export const removeColorTheme = () => localStorage.removeItem(Object.keys(constant)[13]);
export const removeBillerData= () => localStorage.removeItem(Object.keys(constant)[14]);
export const removeLanguage= () => localStorage.removeItem(Object.keys(constant)[15]);
